import { diInject } from '@di/di';
import { CreativeMode } from '@domain/creative/environment';
import { WidgetEvent } from '@domain/widget-events';
import { Widget } from './widget';
export class WidgetRenderer {
    get creativeApi() {
        return this._creativeApi;
    }
    constructor(_env) {
        this._env = _env;
        this.widgets_m = [];
        this.widgetInitializingPromises = [];
        /** Used to wait for async resources that the widget(s) explicitly need */
        this.widgetLoadingPromises = [];
        this._timelineApi = diInject(8 /* Token.TIMELINE_API */);
        this._ad = diInject(0 /* Token.AD */);
        this._animator = diInject(3 /* Token.ANIMATOR */);
        this._tcDataSubscriptions = [];
        this._creativeApi = diInject(7 /* Token.CREATIVE_API */, { args: [_env, this] });
    }
    // Called from renderer
    async createWidget(elementNode, dataNode) {
        const widget = new Widget(elementNode, dataNode, this, this._env);
        this.widgets_m.push({ dataNode, instance: widget });
        this.widgetInitializingPromises.push(widget.isInitialized_m);
        const tcDataSubscription = this._ad.tcDataSubject.subscribe(async (tcData) => {
            await widget.isInitialized_m;
            widget.emit(WidgetEvent.TCData, tcData);
        });
        this._tcDataSubscriptions.push(tcDataSubscription);
        await widget.isInitialized_m;
        if (this._env.MODE === CreativeMode.DesignView) {
            let originalMouseInteraction;
            const originalCursor = widget.cursor;
            widget.cursor = '';
            this._animator.on('play', () => {
                if (typeof originalMouseInteraction === 'undefined') {
                    originalMouseInteraction = widget.mouseInteractions;
                }
                this._creativeApi.environment = 'creative';
                widget.mouseInteractions = originalMouseInteraction;
                widget.cursor = originalCursor;
            });
            this._animator.on('pause', () => {
                this._creativeApi.environment = 'design-view';
                widget.mouseInteractions = false;
                widget.cursor = '';
            });
        }
    }
    destroy(preserveDomListeners = false) {
        this._timelineApi.destroy();
        this._creativeApi.destroy(preserveDomListeners);
        while (this.widgets_m.length) {
            this.widgets_m.pop().instance.destroy();
        }
        for (const subscription of this._tcDataSubscriptions) {
            subscription.unsubscribe();
        }
        this.widgetInitializingPromises = [];
        this.widgetLoadingPromises = [];
    }
    getWidgetInstanceFromIframeId(iframeId) {
        return this.widgets_m.find(widget => iframeId.includes(widget.instance.id));
    }
}
